/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateSnapshotSignRequestDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivSnapshotSignRequestControllerFindAllParamsGen,
  MrfiktivSnapshotSignRequestViewModelGen,
  MrfiktivUpdateSnapshotSignRequestStatusDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class HandoverSnapshotSignRequest<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags handover-snapshot-sign-request
   * @name SnapshotSignRequestControllerCreate
   * @summary Create a snapshot sign request
   * @request POST:/partner/{partnerId}/snapshot-sign-request
   * @secure
   * @response `201` `MrfiktivSnapshotSignRequestViewModelGen` Created sign request
   */
  snapshotSignRequestControllerCreate = (
    partnerId: string,
    data: MrfiktivCreateSnapshotSignRequestDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivSnapshotSignRequestViewModelGen, any>({
      path: `/partner/${partnerId}/snapshot-sign-request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags handover-snapshot-sign-request
   * @name SnapshotSignRequestControllerFindAll
   * @summary Get all sign requests for a snapshot
   * @request GET:/partner/{partnerId}/snapshot-sign-request
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivSnapshotSignRequestViewModelGen)[] })`
   */
  snapshotSignRequestControllerFindAll = (
    { partnerId, ...query }: MrfiktivSnapshotSignRequestControllerFindAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivSnapshotSignRequestViewModelGen[] }, any>({
      path: `/partner/${partnerId}/snapshot-sign-request`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags handover-snapshot-sign-request
   * @name SnapshotSignRequestControllerGetOne
   * @summary Get a sign request
   * @request GET:/partner/{partnerId}/snapshot-sign-request/{id}
   * @secure
   * @response `200` `MrfiktivSnapshotSignRequestViewModelGen` Found sign request
   */
  snapshotSignRequestControllerGetOne = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivSnapshotSignRequestViewModelGen, any>({
      path: `/partner/${partnerId}/snapshot-sign-request/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags handover-snapshot-sign-request
   * @name SnapshotSignRequestControllerDelete
   * @summary Delete a sign request
   * @request DELETE:/partner/{partnerId}/snapshot-sign-request/{id}
   * @secure
   * @response `200` `void` Deleted sign request
   */
  snapshotSignRequestControllerDelete = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/partner/${partnerId}/snapshot-sign-request/${id}`,
      method: "DELETE",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags handover-snapshot-sign-request
   * @name SnapshotSignRequestControllerUpdateStatus
   * @summary Update snapshot sign request status
   * @request PATCH:/partner/{partnerId}/snapshot-sign-request/{id}/status
   * @secure
   * @response `200` `MrfiktivSnapshotSignRequestViewModelGen` Updated sign request
   */
  snapshotSignRequestControllerUpdateStatus = (
    partnerId: string,
    id: string,
    data: MrfiktivUpdateSnapshotSignRequestStatusDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivSnapshotSignRequestViewModelGen, any>({
      path: `/partner/${partnerId}/snapshot-sign-request/${id}/status`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
